import { useEffect, useMemo, useState } from 'react';
import { FCX, ID, Sort } from '@models';
import Table from '@components/Table';
import { useFiltersContext } from '@core/FiltersContext';
import { useItems } from '@api/useItems';
import { FilterApiRequestModel } from '@models/Filter';
import PeopleViewSorting from '@vms/ItemsTable/PeopleViewSorting';
import HomePeopleViewConfig from '@vms/ItemsTable/HomePeopleViewConfig';
import { components } from '@api/api';
import { CONCEPT_LOCKER_INDICATOR_COLOR } from '@core/constants';

const HomePeopleView: FCX<{
    isTopChartOpened?: boolean;
    setTotalRecords?: (value: number) => void;
    setAppliedFilterPayload?: (value: components['schemas']['SearchFilterModel']) => void;
}> = ({
    isTopChartOpened,
    setTotalRecords= () => null,
    setAppliedFilterPayload= () => null,
}) => {
    const {
        options: { totalRespondentType, metrics },
        value: { concepts, peopleSort, metric, display },
        defaultFiltersPayload,
    } = useFiltersContext();

    const [sortingColId, setSortingColId] = useState<ID>(peopleSort.id);
    const [sortingDirection, setSortingDirection] = useState<Sort>(peopleSort.direction);

    const activeRespondentTypesIds: ID[] = useMemo(() => {
        const metricObject = metrics.find(i => i.id === metric);

        if (metricObject) {
            return [
                totalRespondentType,
                ...(metricObject.subItems || [])
            ].map(i => i.id);
        }

        return [];
    }, [metric, metrics, totalRespondentType]);


    const filtersPayload = useMemo((): components['schemas']['SearchFilterModel'] => {
        return {
            filter: {
                ...defaultFiltersPayload,
                respondentTypes: activeRespondentTypesIds as FilterApiRequestModel['respondentTypes'],
                conceptTypeIds: [1, ...concepts] as number[],
                indexType: display as FilterApiRequestModel['indexType'],
            },
            page: {
                sortId: sortingColId as number,
                sortDirection: sortingDirection,
            }
        };
    }, [defaultFiltersPayload, concepts, activeRespondentTypesIds, display, sortingDirection, sortingColId]);

    const {
        data,
        totalRecords,
        fetchMore,
        isLoading,
        copyTableData,
        isCopyTableDataLoading,
    } = useItems(filtersPayload, 60, true);

    useEffect(() => {
        if (!isLoading) {
            setTotalRecords(totalRecords || 0);
        }
    }, [isLoading, totalRecords, setTotalRecords]);

    useEffect(() => {
        setAppliedFilterPayload(filtersPayload);
    }, [filtersPayload, setAppliedFilterPayload]);

    return (
        <>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                marginTop: -16,
                marginBottom: 8,
            }}>
                <div style={{
                    position: 'relative',
                    marginLeft: 12,
                }}>
                    <div
                        className="Indicator"
                        style={{ background: CONCEPT_LOCKER_INDICATOR_COLOR }}
                    />
                    Concept Locker item
                </div>
            </div>
            <PeopleViewSorting
                sortingColId={sortingColId}
                setSortingColId={setSortingColId}
                sortingDirection={sortingDirection}
                setSortingDirection={setSortingDirection}
            >
                <HomePeopleViewConfig data={data}>
                    <Table
                        scrollerKey={isTopChartOpened}
                        rowsCount={data.length}
                        onLoadMore={fetchMore}
                        isLoading={isLoading}
                        copyTable={{
                            data: copyTableData,
                            isLoading: isCopyTableDataLoading,
                        }}
                    />
                </HomePeopleViewConfig>
            </PeopleViewSorting>
        </>
    );
}

export default HomePeopleView;